import React from "react";
import "./Rooms2.css";
const Rooms2 = () => {
  return (
    <div className="pb-5">
      <div className="deluxe">
        <img className="image-1" src="./delux.png" alt="hhh" />
        <p className="centered-1">DELUXE ROOM</p>
      </div>
      <div className="col-12 py-1"></div>
      <div className="deluxe2">
        <div className="sub">
          <img className="image-2" src="./delux1.png" alt="hhh" />
        </div>
        <div className="sub">
          <img className="image-2" src="./delux2.png" alt="hhh" />
        </div>
        <div className="sub">
          <img className="image-2" src="./delux3.png" alt="hhh" />
        </div>
      </div>
      <div className="container-fluid">
        <div className="col-12 py-4"></div>
        <div className="row ">
          <div className="col-1 py-5 ">
            <img className="image-3" src="./Vector 35.png" alt="hhh" />
          </div>
          <div className="col-12 col-md-6 ps-5 ">
            <p className=" text_1">
              Lorem ipsum dolor sit amet consectetur. Adipiscing lectus sit sit
              sed semper vitae faucibus consequat. Sed dui auctor aliquam quam
              urna magna feugiat egestas placerat. Pharetra arcu nulla lacus
              molestie quis dignissim quis tempor interdum. Quam blandit iaculis
              ante pellentesque lectus viverra tristique ultrices. Adipiscing
              purus mattis leo sit mi id sed. Eleifend sed enim odio sapien
              tincidunt viverra. Interdum congue eu bibendum tellus odio.
              Ridiculus posuere ut id imperdiet lorem. Pellentesque turpis mi
              cras vel risus blandit elementum sed neque. Cursus mattis
              vulputate viverra viverra bibendum pharetra cursus. Lobortis
              pulvinar sed lacus vel lobortis. Venenatis nisl a tellus at leo
              sed eget egestas. Blandit ultrices vestibulum nisi lectus purus
              libero maecenas. At dolor amet diam nisl mauris gravida. Id in ut
              varius diam sed viverra viverra. Tincidunt neque vestibulum sociis
              iaculis lobortis eu pellentesque massa. Donec fermentum velit
              tellus libero enim ac tristique in. Aliquet vivamus curabitur
              cursus habitasse malesuada vitae ultrices eget. Dui vivamus quam
              pulvinar ut.{" "}
            </p>
            <p className=" text_11">
              Lobortis pulvinar sed lacus vel lobortis. Venenatis nisl a tellus
              at leo sed eget egestas. Blandit ultrices vestibulum nisi lectus
              purus libero maecenas. At dolor amet diam nisl mauris gravida. Id
              in ut varius diam sed viverra viverra. Tincidunt neque vestibulum
              sociis iaculis lobortis eu pellentesque massa. Donec fermentum
              velit tellus libero enim ac tristique in. Aliquet vivamus
              curabitur cursus habitasse malesuada vitae ultrices eget. Dui
              vivamus quam pulvinar ut.{" "}
            </p>
          </div>

          <div className="col-md-3 ps-4">
            <p className="text-center text_2">Amenities</p>
            <div className="dt d-flex">
              <img className="tele" src="./tele.png" alt="hhh" />
              <p className="text-center text_3">
                Lorem ipsum dolor sit amet consectetur.
              </p>
            </div>
            <div className="dt d-flex">
              <img className="tele" src="./tele.png" alt="hhh" />
              <p className="text-center text_3">
                Lorem ipsum dolor sit amet consectetur.
              </p>
            </div>
            <div className="dt d-flex">
              <img className="tele" src="./tele.png" alt="hhh" />
              <p className="text-center text_3">
                Lorem ipsum dolor sit amet consectetur.
              </p>
            </div>
            <div className="dt d-flex">
              <img className="tele" src="./tele.png" alt="hhh" />
              <p className="text-center text_3">
                Lorem ipsum dolor sit amet consectetur.
              </p>
            </div>
            <div className="dt d-flex">
              <img className="tele" src="./tele.png" alt="hhh" />
              <p className="text-center text_3">
                Lorem ipsum dolor sit amet consectetur.
              </p>
            </div>
            <div className="dt d-flex">
              <img className="tele" src="./tele.png" alt="hhh" />
              <p className="text-center text_3">
                Lorem ipsum dolor sit amet consectetur.
              </p>
            </div>
            <div className="dt d-flex">
              <img className="tele" src="./tele.png" alt="hhh" />
              <p className="text-center text_3">
                Lorem ipsum dolor sit amet consectetur.
              </p>
            </div>
            <div className="dt d-flex">
              <img className="tele" src="./tele.png" alt="hhh" />
              <p className="text-center text_3">
                Lorem ipsum dolor sit amet consectetur.
              </p>
            </div>
          </div>
          <div className="col-2  d-flex tt  ">
            <div className="d-none d-md-block">
              <div className="rott d-flex ">
                <img className="Arrow" src="Arrow 1.png" alt="hhh" />
              </div>
              <div className="rotate d-flex  py-2 mt-md-5">
                <p className="text_4">BOOK NOW</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-2 d-none d-sm-block">
            <div className="rott d-flex ">
              <img className="Arrow" src="Arrow 1.png" alt="hhh" />
            </div>
            <div className="rotate d-flex py-2 mt-5">
              <p className="text_4">BOOK NOW</p>
            </div>
          </div>
          <div className="col-8 text-center ">
            <p className="text-center text_6">View other room types</p>
            <a href="/DeluxRoom">
              <button className="btn-2" type="button">
                <p className="text_7">Deluxe Rooms</p>
              </button>
            </a>
            <a href="/SuiteRoom">
              <button className="btn-2 ms-2" type="button">
                <p className="text_7">Suite Rooms</p>
              </button>
            </a>
          </div>
          <div className="col-2 ">
            <img className="flower" src="./flower.png" alt="hhh" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rooms2;
